import Vue from 'vue'
import setSignature from 'js/services/api/billing/gateway-recharge'
import template from './index.pug'

export default Vue.extend({
  template: template(),

  data() {
    return {
      user: undefined,
      token: '',
      dataR: '',
      removedScripts: [],
      paystoreScript: null,
      urlAPI: Vue.store.getters['runtimeConfig/apiHost'],
      language: Vue.language.getLanguage()
    }
  },

  created() {
    this.dataR = this.getRechargeData()
  },

  mounted() {
    this.configScript()
    this.payWithPayStoreCustom()

    // Agregar el listener para escuchar mensajes del iframe
    window.addEventListener('message', this.handleIframeMessages)
  },

  beforeDestroy() {
    // Clean scripts and close modal
    this.removeScripts()
    this.closeModal()
  },

  methods: {
    configScript() {
      // Finds all scripts and deletes them,
      // Necessary due to conflict with paystore script
      this.removedScripts = document.querySelectorAll('script')
      this.removedScripts.forEach(script => {
        if (script.id !== 'jquery') {
          script.remove()
        }
      })

      // Create script for Paystore
      const base_url = `https://${this.dataR.payment_platform_base_url}`

      this.paystoreScript = document.createElement('script')
      this.paystoreScript.src = base_url
      this.paystoreScript.type = 'text/javascript'
      this.paystoreScript.charset = 'UTF-8'

      document.head.appendChild(this.paystoreScript)

      // Create an observer to wait for div-paystore to load
      const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach(mutation => {
          // Detectar nodos añadidos
          mutation.addedNodes.forEach(node => {
            if (node.id === 'div-paystore') {
              this.centerForm(node) // Ejecuta la acción cuando el div se añade
            }
          })
        })
      })

      // Configurar el observador para observar cambios en el cuerpo
      observer.observe(document.body, {childList: true, subtree: true})
    },

    handleIframeMessages(event) {
      // Procesar el contenido del mensaje
      if (event.data === 'close-modal-paystore') {
        this.$emit('back')
      }
    },

    centerForm(divPaystore) {
      const paystoreContainer = document.getElementById('paystore-container')
      const thirdStep = document.getElementById('recharge_third_step')

      // Obtain the coordinates of the container
      const containerRect = paystoreContainer.getBoundingClientRect()

      // Rewrite default styles
      divPaystore.style.backgroundColor = 'transparent'
      divPaystore.style.top = `${containerRect.top + window.scrollY}px`
      divPaystore.style.left = '0px'
      divPaystore.style.transform = 'translate(100%, -15%)'
      divPaystore.style.overflow = 'hidden'
      divPaystore.style.position = 'absolute'
      thirdStep.style.margin = '-1rem'
      thirdStep.style.padding = '1rem'
    },

    // reset the scripts
    removeScripts() {
      this.removedScripts.forEach(script => {
        document.head.appendChild(script)
      })
      this.paystoreScript?.remove()
      this.paystoreScript = null
      this.removedScripts = []
    },

    closeModal() {
      localStorage.removeItem('rechargeDataS')
      this.dataR = ''
      const modal = document.getElementById('div-paystore')
      modal?.remove()
    },

    getRechargeData() {
      const data = localStorage.getItem('rechargeDataS')

      return data ? JSON.parse(data) : {}
    },

    async payWithPayStoreCustom() {
      try {
        const waitForPayStore = new Promise(resolve => {
          const interval = setInterval(() => {
            if (typeof window.PayStore !== 'undefined') {
              clearInterval(interval)
              resolve(window.PayStore)
            }
          }, 100)
        })

        const PayStore = await waitForPayStore

        // Set config data
        const config = {
          clientId: this.dataR.clientId, // Identificador del cliente comercio. - Obligatorio.
          posId: this.dataR.posId, // Identificador del punto de venta. - Obligatorio.
          groupingUnit: '', // Identificador de la tienda - Opcional
          amount: this.dataR.amount, // Cantidad en céntimos. - Obligatorio
          currency: '978', // Moneda. 978 es el código de la moneda Euro - Obligatorio
          tokenList: '', // Para la gestión de tokens. No se usa por el momento. - Opcional
          user: '', // Usuario asociado al pago 1-click. No se usa por el momento. - Opcional
          description: 'Recargar Moverick', // Descripción de la compra - Opcional
          returnUrl: `${this.urlAPI}/mobile_app/v1/payment/gateways`, // URL confirmación pago - Opcional
          displayType: 'integrada', // Modo en el que se muestra la ventana.
          saveCard: '0', // 0 para mostrar en la pantalla de pago el check de tokenización. – Obligatorio.
          preauth: '0', // valor fijo “0”.
          language: this.language, // Idioma formulario (ISO 639-1) – Obligatorio.
          city: this.dataR.administrative_area_name, // Ciudad donde se realiza la compra - Opcional
          country: 'España', // country: País del usuario que realiza la compra. - Opcional
          phone: '', // - Opcional
          operationClientId: this.dataR.merchant_order, // Identificador de la operación.
          ip: '', // ip: Dirección ip del usuario que realiza la compra. - Opcional
          financeId: '', // código de financiación. Solo si lo requiere la operativa. – Opcional
          transactionType: 'C', // tipo de transacción. – Opcional
          exemptions: '' // listado de exenciones propuestas
        }

        // Indica la cadena que representa la firma de todos los atributos que contiene el body
        const getSignature = await setSignature.generateSignature(config)

        PayStore.configure(
          config.clientId,
          config.posId,
          config.groupingUnit,
          config.amount,
          config.currency,
          config.tokenList,
          config.user,
          config.description,
          config.returnUrl,
          config.displayType,
          config.saveCard,
          config.preauth,
          config.language,
          config.city,
          config.country,
          config.phone,
          config.operationClientId,
          config.ip,
          config.financeId,
          config.transactionType,
          config.exemptions,
          getSignature
        )

        // Start payment confirmation
        await PayStore.payWithPaystore()
      } catch (error) {
        console.error('Error durante el pago:', error)
      }
    }
  }
})
